export const educationData = [
    {
        id: 1,
        institution: 'Julien Day School',
        course: 'ICSE (Class X) ',
        startYear: '2017',
        endYear: '2018'
    },
    {
        id: 2,
        institution: 'Julien Day School',
        course: 'ISC (Class XII) ',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Institute of Engineering and Management',
        course: 'Bachelor of Computer Applications',
        startYear: '2020',
        endYear: '2023'
    },
]